import styled, { css } from 'styled-components';

import * as OD from '@/views/OrderDetailsView/OrderDetailsView.styles';

export const ReturnOrderLineRow = styled(OD.OrderLineRow)<{
  $greyedOut?: boolean;
}>`
  ${({ theme, $greyedOut }) => css`
    padding-top: ${theme.space[2]};
    padding-bottom: ${theme.space[2]};
    ${$greyedOut
      ? css`
          opacity: 0.55;
          filter: grayscale(0.35);
        `
      : ''}
  `}
`;

export const ReturnOrderProductImageInfo = styled(OD.OrderProductImageInfo)`
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
`;

export const ReturnPriceWrap = styled(OD.PriceWrap)`
  ${({ theme }) => css`
    align-self: flex-start;
    padding-top: ${theme.space[1]};
  `}
`;
